import { render, staticRenderFns } from "./ultimas_empresas.vue?vue&type=template&id=1f6744ff&scoped=true&"
import script from "./ultimas_empresas.vue?vue&type=script&lang=js&"
export * from "./ultimas_empresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6744ff",
  null
  
)

export default component.exports